import { useAtom } from "@reatom/npm-react"

import { Label, Slider, Text } from "ui-kit/components-branded/index"
import { defaultQuery } from "modules/PsyCatalog/common/searchQuery"
import { ageAtom } from "modules/PsyCatalog/common/models/filterForm"

export function AgeSelector() {
    const [[ageFrom, ageTo]] = useAtom(ageAtom.inputValue)
    return (
        <>
            <div style={{ overflow: "auto" }}>
                <Label htmlFor="age-range-slider" className="label-with-opacity is-inline-block">
                    Возраст
                </Label>
                <Text className="age-range-text">
                    {ageFrom} – {ageTo}
                </Text>
            </div>
            <Slider
                min={defaultQuery.age_from}
                max={defaultQuery.age_to}
                step={1}
                range={true}
                defaultValue={[defaultQuery.age_from, defaultQuery.age_to]}
                onChange={ageAtom.onChange}
                value={[ageFrom, ageTo]}
            />
        </>
    )
}
